import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../hooks/redux';
import { getCheckoutTotal } from '../../config/salesTax';
import './shoppingNav.scss';

const ShoppingNav = () => {
  const location = useLocation();
  const cartItems = useAppSelector((state) => state.shoppingCart.cartItems);
  const materialPriceAndImgForCart = useAppSelector((state) => state.shoppingCart.materialPriceAndImgForCart);
  const loadingMaterialById = useAppSelector((state) => state.shoppingCart.loadingMaterialById);
  const cartStatus = useAppSelector((state) => state.shoppingCart.status);
  const totalAmount = useAppSelector((state) => state.shoppingCart.totalAmount);
  const taxAmount = useAppSelector((state) => state.shoppingCart.taxAmount);

  const isCart = location.pathname === '/cart';
  const isCheckout = location.pathname === '/cart/checkout';
  const isPayment = location.pathname === '/cart/checkout/payment';
  const isReviewConfirm = location.pathname.includes('/cart/checkout/review-confirm');
  const displayTotal = getCheckoutTotal(totalAmount, taxAmount);
  const shouldShowTotal = cartItems.length > 0 && !isReviewConfirm;
  const isPricingLoading =
    cartStatus === 'loading' ||
    cartItems.some((item) => {
      const materialData = materialPriceAndImgForCart.find((entry) => entry.itemId === item.id);
      return (
        Boolean(loadingMaterialById[item.id]) ||
        !materialData ||
        materialData.selectedMaterial !== item.selectedMaterial
      );
    });

  const steps = [
    { label: 'Cart', to: '/cart', active: isCart, complete: !isCart, backLink: !isCart },
    {
      label: 'Shipping',
      to: '/cart/checkout',
      active: isCheckout,
      complete: isPayment || isReviewConfirm,
      backLink: isPayment || isReviewConfirm,
    },
    {
      label: 'Payment',
      to: '/cart/checkout/payment',
      active: isPayment,
      complete: isReviewConfirm,
      backLink: isReviewConfirm,
    },
    {
      label: 'Review & Confirm',
      to: '/cart/checkout/review-confirm',
      active: isReviewConfirm,
      complete: false,
      backLink: false,
    },
  ];

  return (
    <div className="shopping-nav">
      <div className="shopping-nav__top">
        <div className="shopping-nav__steps" aria-label="Checkout progress">
          {steps.map((step, index) => (
            <React.Fragment key={step.label}>
              {step.backLink ? (
                <Link
                  to={step.to}
                  className={`shopping-nav__step is-link ${
                    step.active ? 'is-active' : step.complete ? 'is-complete' : ''
                  }`}
                >
                  <span className="shopping-nav__step-label">{step.label}</span>
                </Link>
              ) : (
                <div
                  className={`shopping-nav__step ${
                    step.active ? 'is-active' : step.complete ? 'is-complete' : 'is-disabled'
                  }`}
                  aria-current={step.active ? 'step' : undefined}
                >
                  <span className="shopping-nav__step-label">{step.label}</span>
                </div>
              )}
              {index < steps.length - 1 && <span className="shopping-nav__divider" aria-hidden="true" />}
            </React.Fragment>
          ))}
        </div>
        {shouldShowTotal && (
          <div className="shopping-nav__total">
            <span className="shopping-nav__total-label">Total</span>
            <span className="shopping-nav__total-value">
              {isPricingLoading ? 'Loading...' : `$${displayTotal.toFixed(2)}`}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShoppingNav;
